import { Injectable } from '@angular/core';
import type {
  ProductionHistoryHttpQuery,
  ProductionHistoryMonthlyResponse,
  ProductionHistoryQuarterlyResponse,
  ProductionHistoryYearlyResponse,
} from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { ReportingApiService } from './reporting-api.service';

@Injectable({ providedIn: 'root' })
export class ProductionHistoryService {
  private static readonly monthlyPath = '/api/production-history/monthly';
  private static readonly quarterlyPath = '/api/production-history/quarterly';
  private static readonly yearlyPath = '/api/production-history/yearly';

  constructor(private readonly reportingApiService: ReportingApiService) {}

  getMonthlyProductionHistory = (query: ProductionHistoryHttpQuery): Promise<ProductionHistoryMonthlyResponse> =>
    this.reportingApiService.request<ProductionHistoryMonthlyResponse>(ProductionHistoryService.monthlyPath, {
      method: 'GET',
      query,
    });

  getQuarterlyProductionHistory = (query: ProductionHistoryHttpQuery): Promise<ProductionHistoryQuarterlyResponse> =>
    this.reportingApiService.request<ProductionHistoryQuarterlyResponse>(ProductionHistoryService.quarterlyPath, {
      method: 'GET',
      query,
    });

  getYearlyProductionHistory = (query: ProductionHistoryHttpQuery): Promise<ProductionHistoryYearlyResponse> =>
    this.reportingApiService.request<ProductionHistoryYearlyResponse>(ProductionHistoryService.yearlyPath, {
      method: 'GET',
      query,
    });
}
